import Swiper, { Navigation } from "swiper";
import "swiper/scss";

class NewsSlider {
    constructor() {
        this.newsSlider = new Swiper(".news-slider:not(.news-slider--tag) .news-js", {
            modules: [Navigation],
            direction: "horizontal",
            scrollbar: false,
            slidesPerView: 3.2,
            spaceBetween: 28,
            loop: true,
            navigation: {
                nextEl: ".news-slider:not(.news-slider--tag) .news-slider__next--next",
                prevEl: ".news-slider:not(.news-slider--tag) .news-slider__next--prev",
            },
        });
    }
}

export default NewsSlider;
